export default __webpack_public_path__ + "assets/images/arrow.ef60a7da54e3ad48407e387e462ced11.svg";